import { createAsyncThunk } from "@reduxjs/toolkit";
import { StatsFilter, ResponseStats, Stats } from "../../entities/event";
import { apiUrlV1 } from "../../config/config";
import { agent, encodeGetParams } from "../../api";
import { unauthorizedHandler } from "../Auth/authStore";

export const getAnaliticEvents = createAsyncThunk(
  'event/get-analitic-events',
  async (params: { filter?: StatsFilter }, thunksApi): Promise<Stats[]> => {
    try {
      const query = encodeGetParams({ ...params?.filter })
      const response = await agent.get(`${apiUrlV1}/organization/user-events/read/stats${query}`)
      if (response.ok) {
        const data = await response.json() as ResponseStats;
        if (data.user_connected) {
          return data.user_connected;
        }
        return [];
      }
      if (!response.ok && response.status === 401) {
        const body = await response.json();
        thunksApi.dispatch(unauthorizedHandler({ code: body.statusCode, message: body.message, status: true }))
        throw Error("No response");
      }
      if (!response.ok) {
        throw Error("No response");
      }
      return [];
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)